import Vue from 'vue'
import axios from 'axios'

import store from '@/store'
import qs from 'qs'
import {
    isArray
} from '@/utils/validate'

import {Message,} from 'element-ui'
import router from '@/router'

let loadingInstance
const baseURL = process.env.VUE_APP_API_URL
const successCode = [200, 1, -2, -3, -4]

/**
 *
 * @description 处理code异常
 * @param {*} code
 * @param {*} msg
 */
const handleCode = (code, msg) => {
    switch (code) {
        case -1:
            router.push({
                path: '/login'
            }).catch(() => {
            })
            break
        case 429:
            Message({
                offset: 60,
                showClose: true,
                message: `操作太频繁，请稍后再试哦`,
            })
            return;
            break;
        default:
            if (!msg) {
                return
            }

            Vue.prototype.$message({
                message: '网络开小差了，请刷新重试下哦！',
                type: 'error',
            })
            break
    }
}

const instance = axios.create({
    baseURL,
    timeout: 180000,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
    },
})

instance.interceptors.request.use(
    (config) => {
        let token = localStorage.getItem("profly-sdpt-token")
        if (token) {
            config.headers["token"] = token
        }
        if (!config.data) {
            config.data = {}
        }

        if (config.data && config.method == 'get') {
            config.headers['Content-Type'] =
                'application/x-www-form-urlencoded;charset=UTF-8'
            config.url = config.url += `?${qs.stringify(config.data)}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

instance.interceptors.response.use(
    (response) => {
        if (loadingInstance) loadingInstance.close()
        const {
            data,
            config
        } = response
        const {
            code,
            data: msg,
            status
        } = data
        // 操作正常Code数组
        const codeVerificationArray = isArray(successCode) ?
            [...successCode] :
            [...[successCode]]

        //请求第三方地址，直接返回结果
        if (response.config.url.indexOf('http') !== -1) {
            return data
        }
        if (
            codeVerificationArray.includes(code) ||
            codeVerificationArray.includes(Number(status))
        ) {
            return data
        } else {
            handleCode(code, msg)
            return Promise.reject({
                url: config.url,
                code,
                msg
            } || 'Error'
            )
        }
    },
    (error) => {
        if (loadingInstance) loadingInstance.close()
        const {
            response,
            message
        } = error
        if (error.response && error.response.data) {
            const {
                status,
                data
            } = response
            handleCode(status, data.msg || message)
            console.log('----3333---')
            console.log(status)
            if (status == 429) {
                return {code: 429};
            }
            return Promise.reject(error)
        } else {
            let {
                message
            } = error
            if (message === 'Network Error') {
                message = '网络开小差了，请刷新重试下哦！'
            }
            if (message.includes('timeout')) {
                message = '网络开小差了，请刷新重试下哦！'
            }
            if (message.includes('Request failed with status code')) {
                const code = message.substr(message.length - 3)
                message = '网络开小差了，请刷新重试下哦！'
            }
            Message({
                offset: 60,
                showClose: true,
                message: '网络开小差了，请刷新重试下哦！',
            })
            return Promise.reject(error)
        }
    }
)

export default instance